export default (conditionValue: any) => (fieldValue: any) =>
  conditionValue.indexOf(fieldValue) !== -1;
